import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { FormGroup, ReactiveFormsModule } from '@angular/forms'
import { PolicyForm } from '@features/insured/models/policy/policy.model'
import { CommonModule } from '@angular/common'
import { AlbertSelectComponent } from '@shared/components/albert-select/albert-select.component'
import { InsuredBaseForm } from '../insured-base-form.directive'
import { COVERAGE_INSURANCE_TYPE_OPTIONS } from '@shared/models/coverage-insurance.model'

@Component({
  selector: 'albert-policy',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    AlbertSelectComponent
  ],
  templateUrl: './policy.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PolicyComponent extends InsuredBaseForm<PolicyForm> {
  public override readonly form = input.required<FormGroup<PolicyForm>>()
  public readonly policyOptions = input<{ label: string; value: string }[]>()
  protected readonly coverageTypeOptions = COVERAGE_INSURANCE_TYPE_OPTIONS

  protected override getFormGroup(): FormGroup<PolicyForm> {
    return this.form()
  }
}
